<template>
  <div class="py-5">
    <div class="container">
      <h1 class="fw-light">{{ $t('our_artists') }} <span v-if="currentGenre">({{ currentGenre}})</span> <span v-if="showPage"> - {{ $t('page') }} {{ currentPage + 1 }}</span> <span v-if="currentArtist && artist.name"> / {{ artist.name }}</span></h1>
      <div class="row mt-4">
        <div class="col-md-3 col-xs-4 col-sm-4">
          <h3 class="fw-light">{{ $t('main_genre') }}</h3>
          <div class="list-group list-group-bordered">
            <router-link class="list-group-item" :class="{ active: !currentGenre }" to="/our-artists">
              {{ $t('top_artists') }}
            </router-link>
            <router-link class="list-group-item" :class="{ active: currentGenre === genre }" :to="`/our-artists?genre=${genre}`" v-for="(genre, index) in genres" v-bind:key="`genre_${index}`">{{ genre }}</router-link>
          </div>
        </div>
        <div class="col-md-9 col-xs-8 col-sm-8">
          <div class="row">
            <div :class="{ 'row col-md-8': currentArtist === artist.key, 'col-md-4': currentArtist !== artist.key }" v-for="(artist, index) in artists" v-bind:key="`artist_${index}`">
              <div class="card card-profile" :class="{ 'col-md-12': currentArtist !== artist.key, 'col-md-6': currentArtist === artist.key }" >
                <div class="card-header" :style="`background-position: center center; background-image: url('${artist.cover_image_small || artist.cover_image || defaultImage}')`">
                  <div class="profile-picture">
                    <div class="avatar avatar-xl">
                      <a :href="`https://indiefy.me/${artist.key}`" target="_blank" rel="nofollow">
                        <img :src="artist.cover_image_small || artist.cover_image || defaultImage" :alt="artist.name" class="avatar-img rounded-circle" onerror="this.src = '/static/img/img-placeholder.jpg'">
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="user-profile text-center">
                    <router-link :to="`/our-artists/${artist.key}?page=${(currentPage + 1) || ''}&genre=${currentGenre || ''}`" class="name">
                      {{ artist.name }}
                    </router-link>
                    <div class="job">{{ artist.main_genre }}</div>
                    <div class="desc">{{ artist.legal_country }}</div>
                    <div class="social-media" v-if="currentArtist === artist.key && !isCrawler">
                      <a class="btn btn-warning btn-sm btn-link" rel="nofollow" target="_blank" :href="getUrl(artist.instagram, 'instagram')" v-if="artist.instagram">
                        <span class="btn-label just-icon">
                          <i class="flaticon-instagram"></i>
                        </span>
                      </a>
                      <a class="btn btn-info btn-twitter btn-sm btn-link" rel="nofollow" target="_blank" :href="getUrl(artist.twitter, 'twitter')" v-if="artist.twitter">
                        <span class="btn-label just-icon">
                          <i class="flaticon-twitter"></i>
                        </span>
                      </a>
                      <a class="btn btn-primary btn-sm btn-link" rel="nofollow" target="_blank" :href="getUrl(artist.facebook, 'facebook')" v-if="artist.facebook">
                        <span class="btn-label just-icon">
                          <i class="flaticon-facebook"></i>
                        </span>
                      </a>
                      <a class="btn btn-danger btn-sm btn-link" rel="nofollow" target="_blank" :href="getUrl(artist.youtube, 'youtube')" v-if="artist.youtube">
                        <span class="btn-label just-icon">
                          <i class="flaticon-youtube"></i>
                        </span>
                      </a>
                    </div>
                    <div class="view-profile">
                      <a :href="`https://indiefy.me/${artist.key}`" v-if="currentArtist === artist.key" class="btn btn-default btn-block" target="_blank">
                        {{ $t('view_website') }}
                      </a>
                      <router-link v-if="currentArtist !== artist.key" class="btn btn-secondary btn-block" :to="`/our-artists/${artist.key}?page=${(currentPage + 1) || ''}&genre=${currentGenre || ''}`">
                        {{ $t('details') }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-6" v-if="currentArtist === artist.key">
                <div class="card-body">
                  <h2 class="h1">Bio</h2>
                  <p class="text-small">
                    {{ bio }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="clearfix">
            <div class="m-t-sm btn-group pull-right" v-if="!loading">
              <router-link :to="`/our-artists?page=${getPreviousPage() + 1}&genre=${currentGenre || ''}`" class="btn btn-default" :disabled="currentPage == 1"><i class="fa fa-chevron-left"></i></router-link>
              <a href="#" class="btn btn-default">Page {{ currentPage + 1 }} of {{ getTotalPages() }}</a>
              <router-link :to="`/our-artists?page=${getNextPage()}&genre=${currentGenre || ''}`"  class="btn btn-default" :disabled="currentPage >= getTotalPages()"><i class="fa fa-chevron-right"></i></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import genres from '../data/genres'
import Artists from '../services/artists'

export default {
  name: 'PublicArtists',
  data: function () {
    return {
      showPage: false,
      isCrawler: false,
      artist: {},
      bio: '',
      currentArtist: '',
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      searchLimit: 27,
      currentPage: 0,
      loading: true,
      currentGenre: '',
      artists: [],
      results: 0,
      totalArtists: 0,
      lang: 'en',
      genres: _.map(genres, (genre, key) => {
        return key
      })
    }
  },
  methods: {
    setTitle: function () {
      let title = this.$t('our_artists')

      if (this.currentGenre) {
        title += ` (${this.currentGenre})`
      }

      if (this.$route.query.page > 0) {
        title += ` - Page ${this.currentPage + 1}`
      }

      title += ' | Indiefy'

      window.document.title = title
      window.$('meta[property="og:title"]').attr('content', title)
    },
    getPreviousPage: function () {
      if (this.currentPage > 0) {
        return this.currentPage - 1
      } else {
        return 0
      }
    },
    getNextPage: function () {
      if ((this.currentPage + 1) >= this.getTotalPages()) {
        return this.getTotalPages()
      } else {
        return this.currentPage + 2
      }
    },
    getTotalPages: function () {
      return Math.ceil(this.totalArtists / this.searchLimit) || '1'
    },
    getUrl: function (url, suffix) {
      if (!url.match(/http/)) {
        return `https://${suffix}.com/${url}`
      }

      return url
    },
    getBio: function () {
      this.bio = ''

      if (this.currentArtist) {
        Artists.getPublicArtist(this.currentArtist).then(response => {
          this.artist = response.data

          window.document.title = `Indiefy | Listen to ${response.data.name}`
          window.$('meta[property="og:title"]').attr('content', `Indiefy | Listen to ${response.data.name}`)

          if (this.currentGenre) {
            window.document.title += ' (' + this.currentGenre + ')'
          }

          let description = `Listen to ${response.data.name} (${response.data.main_genre}) from ${response.data.legal_country}`

          if (response.data.bio) {
            description = response.data.bio
          }

          window.$('meta[name="description"]').attr('content', description)
          window.$('meta[property="og:description"]').attr('content', description)

          if (response.data.bio) {
            this.bio = response.data.bio
          } else {
            this.bio = `${response.data.legal_name || response.data.name} is a ${response.data.main_genre} artist from ${response.data.legal_country}.`
          }

          this.$forceUpdate()

          setTimeout(() => {
            window.prerenderReady = true
          }, 100)
        })
      }
    },
    getArtists: function () {
      let filter = {
        published: 1,
        limit: this.searchLimit,
        page: this.currentPage,
        search: this.search,
        main_genre: this.currentGenre,
        orderBy: ['spotify_followers', 'popularity']
      }

      this.loading = true
      this.results = 0
      this.totalArtists = 0

      Artists.getPublicArtists(filter).then(response => {
        this.artists = response.data.items
        this.results = response.data.results
        this.totalArtists = response.data.total
        this.loading = false

        if (!this.$route.params.key) {
          setTimeout(() => {
            window.prerenderReady = true
          }, 10)
        }
      })
    }
  },
  watch: {
    '$route': function () {
      this.currentGenre = this.$route.query.genre

      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page) - 1
      } else {
        this.currentPage = 0
      }

      this.showPage = this.$route.query.page

      if (this.currentGenre) {
        window.document.title = `Our Artists (${this.currentGenre}) | Indiefy`
        window.$('meta[property="og:title"]').attr('content', `Our Artists (${this.currentGenre}) | Indiefy`)
      }

      this.currentArtist = this.$route.params.key
      this.setTitle()
      this.getArtists()
      this.getBio()
    }
  },
  created: function () {
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)
    window.prerenderReady = false

    this.lang = this.$i18n.locale
    this.currentGenre = this.$route.query.genre
    this.currentArtist = this.$route.params.key

    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page) - 1
    } else {
      this.currentPage = 0
    }

    this.showPage = this.$route.query.page

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang !== 'en' && this.lang !== 'es') {
      window.$('link[rel="alternate"]').each((index, item) => {
        if (item.hreflang !== 'es' && item.hreflang !== 'en') {
          window.$(item).remove()
        }
      })
    }

    this.setTitle()
    this.getArtists()
    this.getBio()
  }
}
</script>
<style lang="scss" scoped>
.list-group-item {
  border: 0;
  border-left: 3px solid transparent;
  color: #444;

  &:hover {
    background: #fafafa !important;
  }

  &.active {
    background: #fafafa;
    color: #000;
    border-left: 3px solid #1572E8;
  }
}

.user-profile {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.user-profile .name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicArtists.vue